import * as accountApi from '@/network/api/accounts.api.js'
import * as financialApi from '@/network/api/financial.api.js'

/** Fetch Accounts List
@return { promise } - accounts list request
*/
export const accountsListFetch = async (context, payload) => {
    const res = await accountApi.accounts(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_LIST', data)
    }
    return res
}

/** Fetch Financial plan list (of a credit account)
@return { promise } - Financial plan request
*/
export const financialPlanListFetch = async (context, payload) => {
    const res = await financialApi.financialPlanList(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_FINANCIAL_PLAN', { maturityDate: payload.params.maturityDate, data: data })
    }
    return res
}

/** Movements Data
@return { promise } - Movements
*/
export const movimentsFetch = async (context, payload) => {
    const res = await accountApi.requestMoviments(payload)
    if (res) {
        const data = res.data.data
		context.commit('SAVE_MOVEMENTS', { pageNumber: payload.params.pageNumber, data: data })
    }
    return res
}

/** Movement Detail
@return { promise } - Movements Detail request
*/
export const requestMovimentDetail = async (context, payload) => {
    const res = await accountApi.requestMovimentDetail(payload)
    return res
}

/** Account Informations List
@return { promise } - Account Informations List request
*/
export const accountInformationsRequest = async (context, payload) => {
    const res = await accountApi.requestAccountDetails(payload)
    return res
}

/** requests Account Detail Update
@return {promise} - Accounts Detail Update request
*/
export const updateAccountDescription = async (context, payload) => {
    const res = await accountApi.updateAccountDescription(payload)
    if (res) context.commit('SAVES_NEW_ACCOUNT_DESCRIPTION', { payload, responseData: res.data.data })
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
